<template>
  <div class="profile">
    <v-container fluid>
      <div class="text-h5 ml-2" id="profile-avatar">
        <profile-image :upload="true" :size="'150px'" text-size="text-xl-body-1"></profile-image>
      </div>
      <v-card class="mx-auto mt-16 pl-10 pr-10 pt-10 pb-10">
        <v-row class="mt-2">
          <v-col cols="12" class="d-flex justify-end">
            <v-btn
              depressed
              large
              rounded
              class="white--text font-weight-bold"
              color="primary200"
              @click="edit = true"
              v-if="!edit"
            >
              <v-icon>mdi-pencil-outline</v-icon>
              {{ $t('edit') }}
            </v-btn>
          </v-col>
        </v-row>
        <profile-info :editable="edit" @cancel="edit = false"></profile-info>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import ProfileImage from '@/components/shared/profile/ProfileImage';
import ProfileInfo from '@/components/shared/profile/ProfileInfo';

export default {
  name: 'Profile',
  components: { ProfileImage, ProfileInfo },
  data() {
    return {
      edit: false,
    };
  },
};
</script>
